import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-label m-0" }
const _hoisted_2 = { class: "row-container" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "m-0" }
const _hoisted_5 = { class: "text-label mmt-2" }
const _hoisted_6 = ["value", "placeholder", "disabled", "onInput"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RcButton = _resolveComponent("RcButton")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_KeyValue = _resolveComponent("KeyValue")!
  const _component_ArrayList = _resolveComponent("ArrayList")!
  const _directive_t = _resolveDirective("t")!
  const _directive_clean_html = _resolveDirective("clean-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("h3", null, null, 512), [
      [_directive_t, 'fleet.gitRepo.paths.title']
    ]),
    _cache[7] || (_cache[7] = _createTextVNode()),
    _createElementVNode("p", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.t('fleet.gitRepo.paths.description1')), 1),
      _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.t('fleet.gitRepo.paths.description2')), 1)
    ]),
    _cache[8] || (_cache[8] = _createTextVNode()),
    _createVNode(_component_ArrayList, {
      "data-testid": "gitRepo-paths",
      class: "mmt-4",
      value: $options.paths,
      mode: $props.mode,
      "initial-empty-row": false,
      "a11y-label": _ctx.t('fleet.gitRepo.paths.ariaLabel'),
      "add-label": _ctx.t('fleet.gitRepo.paths.addLabel'),
      "add-icon": 'icon-plus',
      "add-class": 'btn-sm role-secondary',
      protip: _ctx.t('fleet.gitRepo.paths.tooltip', {}, true),
      "remove-allowed": false,
      onAdd: $options.onAddPath,
      "onUpdate:value": $options.updatePaths
    }, {
      columns: _withCtx(({row, i}) => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.t('fleet.gitRepo.paths.index', { index: i + 1 }, true)), 1),
              _cache[2] || (_cache[2] = _createTextVNode()),
              (!$options.isView)
                ? (_openBlock(), _createBlock(_component_RcButton, {
                    key: 0,
                    size: "small",
                    variant: "link",
                    onClick: ($event: any) => ($options.removePaths(i))
                  }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createElementVNode("i", { class: "icon icon-x" }, null, -1)
                    ])),
                    _: 2,
                    __: [1]
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _cache[3] || (_cache[3] = _createTextVNode()),
            _withDirectives(_createElementVNode("p", _hoisted_5, null, 512), [
              [_directive_clean_html, _ctx.t('fleet.gitRepo.paths.description')]
            ]),
            _cache[4] || (_cache[4] = _createTextVNode()),
            _createElementVNode("input", {
              ref: `path-input-${ i }`,
              "data-testid": "main-path",
              class: "mt-5",
              value: row.value,
              placeholder: _ctx.t('fleet.gitRepo.paths.placeholder'),
              disabled: $options.isView,
              onInput: ($event: any) => ($options.updatePath(i, $event))
            }, null, 40, _hoisted_6),
            _cache[5] || (_cache[5] = _createTextVNode()),
            (!$options.isView)
              ? (_openBlock(), _createBlock(_component_Checkbox, {
                  key: 0,
                  value: $data.rows[i]?.isBundles,
                  class: "check mmt-4",
                  type: "checkbox",
                  "label-key": "fleet.gitRepo.paths.enableBundles",
                  mode: $props.mode,
                  disabled: !$options.paths[i],
                  "onUpdate:value": ($event: any) => ($options.updateIsBundles(i))
                }, null, 8, ["value", "mode", "disabled", "onUpdate:value"]))
              : _createCommentVNode("", true)
          ]),
          _cache[6] || (_cache[6] = _createTextVNode()),
          ($data.rows[i]?.isBundles)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["subpaths", { ['mt-10']: $options.isView }])
              }, [
                _createVNode(_component_KeyValue, {
                  value: $data.rows[i]?.subpaths,
                  mode: $props.mode,
                  "key-name": 'base',
                  "value-name": 'options',
                  "key-label": _ctx.t('fleet.gitRepo.paths.subpaths.props.base'),
                  "value-label": _ctx.t('fleet.gitRepo.paths.subpaths.props.options'),
                  "as-map": false,
                  "value-can-be-empty": true,
                  "read-allowed": false,
                  "initial-empty-row": true,
                  "key-placeholder": $options.isView ? ' ' : _ctx.t('fleet.gitRepo.paths.subpaths.placeholders.key'),
                  "value-placeholder": $options.isView ? ' ' : _ctx.t('fleet.gitRepo.paths.subpaths.placeholders.value'),
                  "add-label": _ctx.t('fleet.gitRepo.paths.subpaths.addLabel'),
                  "add-icon": 'icon-plus',
                  "add-class": 'btn-sm role-tertiary',
                  "remove-label": ' ',
                  "remove-icon": 'icon-x',
                  protip: false,
                  "protip-value": _ctx.t('fleet.gitRepo.paths.subpaths.protipValue'),
                  "onUpdate:value": ($event: any) => ($options.updateSubpaths(i, $event))
                }, null, 8, ["value", "mode", "key-label", "value-label", "key-placeholder", "value-placeholder", "add-label", "protip-value", "onUpdate:value"])
              ], 2))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["value", "mode", "a11y-label", "add-label", "protip", "onAdd", "onUpdate:value"])
  ], 64))
}